function Localization(mainLocale)
{
    this.mainLocale = mainLocale;
    return this;
}

Localization.prototype.setMain = function(mainLocale)
{
    this.mainLocale = mainLocale;
    this.localization = mainLocale;
    return this;
};

Localization.prototype.set = function(regionLocale)
{
    this.localization = this._mergeLocalization(this.mainLocale, regionLocale);
    return this;
};

Localization.prototype.get = function()
{
    let pathArr = this._splitLocalizationPath(arguments);

    // watcher(pathArr);
    return this._getLocaleValue(pathArr, this.localization);
};

Localization.prototype._splitLocalizationPath = function(args)
{
    let keyPath = [];

    args = Array.prototype.slice.call(args);

    for (let key in args)
    {
        if (args.hasOwnProperty(key))
        {
            keyPath.push(args[key])
        }
    }

    let result = [];

    keyPath.forEach( function(item)
    {
        result = result.concat(String(item).split('.'));
    });

    return result
};

Localization.prototype._mergeLocalization = function(mainLocale, regionLocale)
{
    let result = this.cloneObj(mainLocale);

    if (!regionLocale)
    {
        return result;
    }

    let regLocale =  this.cloneObj(regionLocale);
    for (let key in regLocale)
    {
        if (regLocale.hasOwnProperty(key))
        {
            let value = mainLocale[key];
            let regionValue = regLocale[key];

            if (typeof value === "object")
            {
                result[key] = this._mergeLocalization(value, regionValue);
                continue;
            }

            if (regionValue || regionValue === 0)
            {
                result[key] = regionValue;
            }
        }
    }
    return result;
};

Localization.prototype._getLocaleValue = function(pathArr, locale)
{
    let key = pathArr.shift();

    if (!locale.hasOwnProperty(key))
    {
        return '';
    }

    if (!pathArr.length)
    {
        return locale[key];
    }

    return this._getLocaleValue(pathArr, locale[key])
};

Localization.prototype.cloneObj = function (obj)
{
    return JSON.parse(JSON.stringify(obj))
};

export default new Localization();
